/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Scaffold = require('common/layout/Scaffold');
var NProgress = require('nprogress');
var NavUtils = require('psa-core/util/nav');

var ComplaintFormView = require('../views/ComplaintForm.js');

module.exports = function() {
  window.location.href = 'https://www.portal.dobs.pa.gov/#ext/conser/complaint/new';
  NProgress.start();
  NProgress.set(0.6);
  //  NavUtils.navigate('pub/complaintform');
  //  Scaffold.content.show(new ComplaintFormView({}));
  NProgress.done();
};

